import "leaflet";
import "src/decidim/vendor/leaflet-tilelayer-here";
$(() => {
  $("[data-decidim-map]").on("configure.decidim", (_ev, map, mapConfig) => {
    L.tileLayer.here(mapConfig.tileLayer).addTo(map);
  });
});
